import { AdminClientMetric } from './AdminClientMetric';

export default AdminClientMetric;